import { LoadingButton } from '@mui/lab';
import { Box, Button, FormHelperText } from '@mui/material';
import { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Proptypes from 'prop-types';

import { parseIccids, validateIccidList } from '../../utils/iccid';

// One bad cell rejects the whole upload server-side, so the file is parsed and
// previewed here first and only a clean file can be submitted.
const IccidOrganizationFileUpload = ({ onSubmit, loading, disabled }) => {
  const [file, setFile] = useState();
  const [preview, setPreview] = useState({ count: 0, error: null });

  const handleChangeForm = (event) => {
    const [selected] = event.target.files;
    event.target.value = '';
    if (!selected) return;

    setFile(selected);
    selected.text().then((text) => {
      const parsed = parseIccids(text);
      setPreview({ count: parsed.iccids.length, error: validateIccidList(parsed) });
    });
  };

  return (
    <Box paddingTop={4}>
      <Box display="flex" alignItems="center">
        <Button variant="contained" component="label">
          Upload File
          <input onChange={handleChangeForm} type="file" accept=".csv,.txt,text/csv,text/plain" hidden />
        </Button>
        {file && (
          <Box display="flex" alignItems="center" marginLeft={4}>
            {file.name}
            {preview.error ? (
              <ErrorOutlineIcon sx={{ marginLeft: 1 }} color="error" />
            ) : (
              <CheckCircleOutlineIcon sx={{ marginLeft: 1 }} color="success" />
            )}
          </Box>
        )}
      </Box>
      <FormHelperText error={!!preview.error} sx={{ mt: 1 }}>
        {file ? preview.error || `${preview.count} distinct ICCIDs` : 'CSV or TXT, one ICCID per cell, up to 1000'}
      </FormHelperText>

      <LoadingButton
        loading={loading}
        disabled={disabled || loading || !file || !!preview.error}
        onClick={() => onSubmit('file', file)}
        sx={{ my: 2 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

IccidOrganizationFileUpload.propTypes = {
  onSubmit: Proptypes.func,
  loading: Proptypes.bool,
  disabled: Proptypes.bool,
};
export default IccidOrganizationFileUpload;
